import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
import { Delete } from './delete';
import { Edit } from './edit';
import { DropdownHeader } from './header';

const StyledMenu = styled(AntMenu)`
  width: 240px;
  padding: var(--spacing-05) 0;
  max-height: 70vh;
  overflow: auto;

  .ant-dropdown-menu-item-group-list {
    margin: 0;
  }
  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    display: flex;
    align-items: center;
    padding: var(--spacing-02) var(--spacing-05);
  }
  .ant-dropdown-menu-item.ant-dropdown-menu-item-danger.ant-dropdown-menu-item-disabled {
    color: var(--gray-40);
    &:hover {
      color: var(--gray-40);
      background-color: var(--white-100);
    }
  }

  .ant-dropdown-menu-item .ant-menu-item-icon,
  .ant-dropdown-menu-item .ant-dropdown-menu-item-icon,
  .ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-vertical
    > .ant-dropdown-menu-submenu-title
    > svg {
    margin-right: var(--spacing-03);
  }

  .ant-dropdown-menu-item-divider {
    margin: var(--layout-01) 0;
  }
`;

const Menu: Menu = StyledMenu as any;
const ItemWithPermission = withHideIfNotAllowed(AntMenu.Item);

type ItemType = typeof ItemWithPermission;

Menu.Header = DropdownHeader;
Menu.ItemDelete = Delete;
Menu.ItemEdit = Edit;
Menu.ItemWithPermission = ItemWithPermission as ItemType;

type Menu = typeof AntMenu & {
  Header: typeof DropdownHeader;
  ItemDelete: typeof Delete;
  ItemEdit: typeof Edit;
  ItemWithPermission: ItemType;
};

export { Menu };
